<template>
    <div style="display:grid;grid-template-columns: 14% 4% 14% 14% 38% 4% 12%;grid-template-rows: 60px;background: #ddd;padding-left:70px;">
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Date
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            DOW
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Aircraft Config.
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Flight Number(s)
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Schedule / Slot
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Service Type
        </span>
        <span style="font-size: 1rem; margin: 0; color: #666;display: flex;align-items: center;">
            Warnings
        </span>
    </div>
</template>

<script>
    export default {
        name: 'SelectedFlightListHeader',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {};

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListHeader.vue >>> created');

        }, // eo function created()



        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListHeader.vue >>> destroyed');

        }, // eo function destroyed()



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>
